import { useEffect, useState } from 'react';

type TCleanup = () => void;

/**
 * Подписывается на window.load или сразу вызывает callback, если страница уже загружена.
 * На SSR (без window) ничего не делает.
 */
export function setupAfterWindowLoad(onLoad: () => void): TCleanup | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  if (document.readyState === 'complete') {
    onLoad();

    return undefined;
  }

  const handleLoad = (): void => {
    onLoad();
  };

  window.addEventListener('load', handleLoad);

  return () => {
    window.removeEventListener('load', handleLoad);
  };
}

/**
 * Возвращает true после события window.load (или сразу, если страница уже загружена).
 * Нужен, чтобы тяжёлые ресурсы не блокировали load и связанные с ним скрипты аналитики.
 */
export const useAfterWindowLoad = (): boolean => {
  const [isAfterLoad, setIsAfterLoad] = useState(false);

  useEffect(() => {
    return setupAfterWindowLoad(() => {
      setIsAfterLoad(true);
    });
  }, []);

  return isAfterLoad;
};
